<template lang="pug">
v-container(fluid).re-filters
  portal(to="slots-type-choosing")
  v-row(wrap)
    v-col(cols="12" md="3" tile)
      filter-autocomplete-loaded(
        v-model="model.filters.location" 
        :getItems="getExamLocations"
        multiple
        showCloseMenuBtn
        closeOnInputClick
        label="Location"
        hideDetails
        showSelectedIcon
        testName="slots-location-input"
        :redirectName="$ROUTER_NAMES.LOGIN_EXERCISE"
      )
      filter-autocomplete-loaded(
        v-model="model.filters.productName" 
        :getItems="getProductNames"
        multiple
        showCloseMenuBtn
        closeOnInputClick
        label="Product name"
        hideDetails
        showSelectedIcon
        item-text="name"
        item-value="name"
        :redirectName="$ROUTER_NAMES.LOGIN_EXERCISE"
      )
    v-col(cols="12" md="3" tile)
      datepicker(
        v-model="model.filters.examDateAfter"
        hideDetails
        testName="slots-date-after"
        label="Exam date start"
      )
      datepicker(
        v-model="model.filters.examDateBefore"
        hideDetails
        testName="slots-date-before"
        label="Exam date end"
      )
    v-col(cols="12" md="3")
      datepicker(
        v-model="model.filters.examTimeAfter"
        label="Exam time start"
        icon='mdi-clock-outline'
        convertToDefault=false
        timepicker
      )
      datepicker(
        v-model="model.filters.examTimeBefore"
        label="Exam time end"
        icon='mdi-clock-outline'
        convertToDefault=false
        timepicker
      )
    v-col(cols="12" md="3")
      v-select(
        item-value="key" 
        item-text="label" 
        :items="model.options.weekDays.list"
        v-model="model.filters.weekDay"
        hide-details
        label="Week day"
        clearable
        :menu-props="{contentClass: 'menu-with-scroll-visible'}"
      ) 
      filter-autocomplete(
        v-model="model.filters.cbrUser" 
        :items="cbrUsers"
        multiple
        showCloseMenuBtn
        closeOnInputClick
        label="CBR user"
        item-text="username"
        item-value="ID"
        hideDetails
        field="cbrUser"
        showSelectedIcon
        :redirectName="$ROUTER_NAMES.LOGIN_EXERCISE"
      )

  v-btn(outlined data-test="slots-submit" @click="filtersChanged").btn-common Apply
</template>

<script>
import {mapGetters, mapMutations, mapActions} from "vuex"
import FiltersModel, {FILTERS_ARGS} from "../core/models/reservedFiltersModel.js"

export default {
  data: () =>({
    model: null
  }),

  created() {
    this.init()
  },

  computed: {
    ...mapGetters({
      cbrUsers: 'cbrUser/items'
    })
  },

  mounted() {
    this.setTypeAccordingToQuery()
    this.setDefaultExamDate()
  },

  inject: ['getDefaultPagination'],

  methods: {
    ...mapActions({
      getExamLocations: 'crmExamLocation/list',
      getProductNames: 'crmProductNames/list'
    }), 

    init() {
      this.model = new FiltersModel(this.$route.query)
    },
    
    setTypeAccordingToQuery() {
      if(!this.$route.query.type) return
      this.setActiveType(this.$route.query.type)
    },
    
    setDefaultExamDate() {
      if(this.$route.query[FILTERS_ARGS.EXAM_DATE_AFTER]) return
      this.model.setDefaultExamDate()
    },

    async setQuery() {
      try {
        await this.$router.replace(
          {query: 
            { 
              ...this.$route.query, 
              ...this.getDefaultPagination(), 
              ...this.model.getApiData()
            }}
        )
      } catch (error) {
        console.log(error)
      }
    },

    async filtersChanged() {
      await this.setQuery()
      this.$emit('filterChanged')
    }
  },

  components: {
    FilterAutocomplete: () => import('@/app/admin/components/FilterAutocompleteChecked.vue'),
    Datepicker: () => import('@/app/admin/components/CrmDatepicker.vue'),
    FilterAutocompleteLoaded: () => import('@/components/global/FilterAutocomplete.vue'),
    Search: () => import('@/components/global/Search.vue')
  }
}
</script>

<style lang="scss" scoped>
.res-search {
  box-shadow: 0 1px 1px 0px #ccc;
}
.re-filters {
  padding-left: 14px;
  padding-right: 14px;
}

.search::v-deep {
  &.v-input .v-text-field__slot input {
    padding: 8px 0 8px;
    // padding: 0 !important;
  }
}
</style>